import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Tooltip } from 'antd'
import styled from 'styled-components'
import { BeamerHelmet } from 'react-beamer'

import { colours } from '@qflow/theme'
import { icons } from 'portal/lib/primitives'

declare global {
  interface Window {
    Beamer?: any
  }
}

export function AnnouncementLink() {
  const auth = useSelector((state: any) => state.auth)

  useEffect(() => {
    // Track the component mount
    if (window.Beamer) {
      window.Beamer.update({
        user_id: auth?.userUuid || 'anonymous'
      })
    }
  }, [auth])

  return (
    <Container>
      <Tooltip title={'Announcements and news'} placement="bottom">
        <BeamerHelmet
          data-testid="beamer-helmet"
          id={'EjUcOgdC69078'}
          args={{ selector: 'beamerButton' }}
        />
        <BeamerButtonContainer>
          <BeamerButton id="beamerButton">
            <icons.Announcement colour="currentColor" />
          </BeamerButton>
        </BeamerButtonContainer>
      </Tooltip>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: initial;
  align-items: center;
`
const BeamerButtonContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: initial;
  align-items: center;
`
const BeamerButton = styled.div`
  display: flex;
  align-content: center;
  height: 40px;
  width: 40px;
  border: 1px solid ${colours.CORE_NAVY};
  border-radius: 20px;
  color: ${colours.CORE_NAVY};
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus {
    color: ${colours.TEAL};
    background-color: ${colours.CONTROL_PANEL_GREY};
    border-color: ${colours.TEAL};
  }
`
